module.exports = __webpack_public_path__ + "img/gamechar_desert.c45978bd.jpg";